import React from 'react'
import type { HTMLElementProps } from '~/types'

type Props = HTMLElementProps<'svg'>

export const Expand: React.FC<Props> = props => (
	<svg xmlns="http://www.w3.org/2000/svg" height="1em" fill="currentColor" viewBox="0 0 299 299" {...props}>
		<path d="M43 192H0v107h107v-43H43zM0 107h43V43h64V0H0zM192 0v43h64v64h43V0zM256 256h-64v43h107V192h-43z" />
	</svg>
)
